<template>
  <div>
    <div>
      <el-dialog title="添加供应商" :visible.sync="disableDialog" append-to-body width="580px">
        <el-form
          :model="queryParams"
          label-width="100px"
          style="padding:0px 30px;"
          ref="queryParamsRefs"
        >
          <el-form-item label="供应商名称：" prop="suName" :rules="filter_rules({ required: true })">
            <el-row>
              <el-col :span="18">
                <el-input @change="changeSuName" v-model.trim="queryParams.suName"></el-input>
              </el-col>
              <el-col :span="4">
                <el-button style="margin-left:10px;" @click="suNameChange(queryParams.suName)">查询</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="供应商类型："
            prop="suType"
            :rules="filter_rules({ required: true, type: 'change' })"
          >
            <el-select v-model.trim="queryParams.suType">
              <el-option label="平台渠道" :value="1"></el-option>
              <el-option label="供应商" :value="2"></el-option>
              <el-option label="厂家" :value="3"></el-option>
              <el-option label="经销商" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款方式：">
            <el-select v-model.trim="queryParams.payType">
              <el-option label="全款发货" value="全款发货"></el-option>
              <el-option label="先货后款" value="先货后款"></el-option>
              <el-option label="约定账期" value="约定账期"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="queryParams.payType === '约定账期'" label="账期设置：" prop="payTypeStatus">
            <el-row>
              <el-col :span="10">
                <el-select v-model.trim="queryParams.accountType" placeholder="约定条件">
                  <el-option
                    v-for="(item, index) in appointList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="10">
                <el-input placeholder="约定天数" v-model.trim="queryParams.days"></el-input>
              </el-col>
              <el-col :span="2">{{'天'}}</el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="联系人名称："
            prop="staffUsename"
            :rules="filter_rules({ required: true })"
          >
            <el-input v-model.trim="queryParams.staffUsename"></el-input>
          </el-form-item>
          <el-form-item
            label="联系人电话："
            prop="staffPhone"
            :rules="
          filter_rules({
            required: true,
            trigger: 'blur'
          })
        "
          >
            <el-input v-model.trim="queryParams.staffPhone" @input="onlyNumber" maxlength="25"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-center">
          <el-button type="primary" @click="onSubmit">提 交</el-button>
          <el-button @click="onClose">取 消</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 验证码 -->
    <qrcode-dialog @qrcodeDialog="qrcodeDialog" ref="qrcodeDialogRefs"></qrcode-dialog>
    <!--------------查询企业 -------------->
    <invoice-search-dialog @invoiceSearchDialog="invoiceSearchDialog" ref="invoiceSearchDialogRefs"></invoice-search-dialog>
  </div>
</template>
<script>
import invoiceSearchDialog from '@/views/crm/components/custorm/dialog/invoiceSearchDialog'
import { queryEnterQueryEin } from '@/api/customer/customerManage'
import { addSupplier } from '@/api/purchase/purchaseManage'
import qrcodeDialog from '@/views/crm/components/custorm/dialog/qrcodeDialog'

export default {
  components: {
    'qrcode-dialog': qrcodeDialog,
    'invoice-search-dialog': invoiceSearchDialog
  },
  data () {
    return {
      // validPhone: validPhone,
      disableDialog: false,
      queryParams: {},
      appointList: [
        { value: 1, label: '发货后' },
        { value: 2, label: '发货+开票后' },
        { value: 3, label: '开票后' }
      ]
    }
  },
  methods: {
    changeSuName () {
      delete this.queryParams.taxNumber
    },
    invoiceSearchDialog (val) {
      this.queryParams.suName = val.entname
      this.queryParams.suElp = val.legalname
      this.queryParams.suRegdate = val.esdate
      queryEnterQueryEin(val.id)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams.suProvince = res.data.obj.province
            this.queryParams.taxNumber = res.data.obj.taxnumber
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查询
    suNameChange (suName) {
      this.$refs.qrcodeDialogRefs.onInitial(suName)
    },
    // 添加供应商弹窗初始化
    onInitial () {
      this.queryParams = {}
      this.disableDialog = true
    },
    onlyNumber (value) {
      this.queryParams.staffPhone = value.replace(/[^\d]/g, '')
    },
    qrcodeDialog (formLabelAlign, data) {
      this.$refs.invoiceSearchDialogRefs.onInitial(data, formLabelAlign, 'suName')
    },
    // 确定
    onSubmit () {
      this.$refs.queryParamsRefs.validate((valid) => {
        if (valid) {
          if (this.queryParams.taxNumber === undefined) {
            this.$message.error('请进行供应商名称查询！')
          } else if (this.queryParams.payType === '约定账期') {
            if (
              this.queryParams.accountType === undefined ||
              this.queryParams.days === undefined ||
              this.queryParams.days === ''
            ) {
              this.$message.error('请进行账期设置！')
            } else {
              addSupplier(this.queryParams).then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('已成功添加供应商')
                  this.$refs.queryParamsRefs.resetFields()
                  this.$emit('addSupplier')
                  this.disableDialog = false
                } else {
                  this.$message.error(res.data.msg)
                }
              })
            }
          } else {
            delete this.queryParams.accountType
            delete this.queryParams.days
            addSupplier(this.queryParams).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('已成功添加供应商')
                this.$refs.queryParamsRefs.resetFields()
                this.$emit('addSupplier')
                this.disableDialog = false
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        } else {
          this.$message.error('必填项不可为空！')
        }
      })
    },
    // 取消
    onClose () {
      this.disableDialog = false
      this.$refs.queryParamsRefs.resetFields()
    }
  }
}
</script>
